module.exports = __webpack_public_path__ + "img/img.45aae38c.jpg";